import { Wallet } from "lucide-react";

export default function WalletPanel({ wallet, balance, withdrawing, onWithdraw }) {
  return (
    <section className="gold-frame paper-scroll rounded-sm p-6 sm:p-8 mb-8" data-testid="wallet-panel">
      <div className="flex flex-wrap items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Wallet className="w-4 h-4 text-[#D9B472]" />
            <span className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass">Author Wallet</span>
          </div>
          <div className="font-mono-brass text-4xl text-[#F7F3EC]">${balance}</div>
          <div className="text-sm text-[#A8A095] font-serif-body italic mt-1">Sales & tips settle here instantly.</div>
        </div>
        <button
          onClick={onWithdraw}
          disabled={withdrawing || (wallet?.wallet_cents || 0) < 100}
          className="btn-buy px-6 py-3.5 rounded-sm font-mono-brass text-xs uppercase tracking-widest font-semibold disabled:opacity-50"
          data-testid="author-wallet-withdraw-button"
        >
          {withdrawing ? "Processing…" : `Withdraw $${balance}`}
        </button>
      </div>

      {wallet?.withdrawals?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-[rgba(217,180,114,0.1)]">
          <div className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass mb-3">Recent payouts</div>
          <div className="space-y-2">
            {wallet.withdrawals.slice(0, 5).map((wd) => (
              <div key={wd.id} className="flex justify-between text-sm">
                <span className="text-[#A8A095] font-serif-body">
                  {new Date(wd.created_at).toLocaleDateString()} ·{" "}
                  <span className="font-mono-brass text-[#6E675E] uppercase tracking-widest text-[10px]">{wd.kind || "simulated"}</span>
                </span>
                <span className="text-[#D9B472] font-mono-brass">${(wd.amount_cents / 100).toFixed(2)} · {wd.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
